export default __webpack_public_path__ + "static/media/frg--outdoor-lagoon-pool.4cede086.png";